import { render, staticRenderFns } from "./TechnicalDashboardViewTable.vue?vue&type=template&id=0aff7d76&lang=pug&"
import script from "./TechnicalDashboardViewTable.vue?vue&type=script&lang=js&"
export * from "./TechnicalDashboardViewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports